import React, { useEffect } from 'react';
import InputRange from 'react-input-range';
import useBindToContext from 'hooks/useBindToContext';
import 'styles/range.css';

const Range = ({
	max = 100,
	min = 0,
	step = 1,
	value = null,
	onChange = null,
	BindToContext = null,
	validation = true,
	getError = null,
	specificValidation = null,
	formatter = (value) => parseFloat(value.toFixed(2)),
}) => {
	const [BindedValue, BindedOnChange, onRender] = useBindToContext(
		BindToContext,
		value,
		onChange,
		specificValidation,
		getError,
		validation
	);

	//useEffect(() => {
		//if (onRender?.length) onRender.forEach(fn => fn());
	//}, [onRender]);

	return (
		<InputRange
			maxValue={max}
			minValue={min}
			step={step}
			style={{
				zIndex: 1,
				marginBottom: 20,
			}}
			value={parseFloat(BindedValue)}
			onChange={(value) => BindedOnChange(formatter(value))}
		/>
	);
};

export default Range;
